export default __webpack_public_path__ + "static/Greycliffcf-heavy-webfont-dd534ae0bd24ac8f2436e0f8469c400b.woff";